@if ({ isMobile: isMobile$ | async, presetDisplayName: presetDisplayName$ |
async, totalFilters: totalFilters$ | async, filterShortcutConfig:
filterShortcutConfig$ | async, productsLoading: productsLoading$ | async,
resultCount: resultCount$ | async }; as ctx) { @if(ctx.filterShortcutConfig) {
<button
  (click)="$event.stopPropagation(); goToShortcut(ctx.filterShortcutConfig)"
  class="btn btn-success filters-button px-0 d-flex align-items-center mr-1"
  data-e2e="discounts-button"
  type="button"
>
  <span class="px-2">
    <span
      i18n="
        searchBar|Filters shortcut button text@@searchBarFiltersShortcutText"
      class="d-inline-block mr-1"
      >Discounts</span
    ><fa-icon size="xs" [icon]="['fas', 'chevrons-right']"></fa-icon>
  </span>
</button>
} @if(showFiltersButton()) {
<button
  (click)="$event.stopPropagation(); toggleModal(true); refreshAccordions()"
  class="btn btn-primary filters-button px-0 d-flex align-items-center"
  data-e2e="filters-button"
  type="button"
>
  @if (ctx.totalFilters) {
  <span class="pl-2">
    {{ ctx.totalFilters }}
  </span>
  }
  <span
    class="filters-button-icon d-flex align-items-center justify-content-center flex-shrink-0"
  >
    <fa-icon size="xs" [icon]="filterIcon"></fa-icon>
  </span>
  @if (ctx.presetDisplayName) {
  <span
    i18n="searchBar|Filters button text@@searchBarFiltersText"
    [attr.data-e2e]="'filter-preset-' + ctx.presetDisplayName"
    class="d-inline-flex align-items-center justify-content-center w-100 pr-2 pl-1"
    >{{ ctx.presetDisplayName }}</span
  >
  } @else {
  <span
    i18n="searchBar|Filters loading button text@@searchBarLoadingFiltersText"
    class="d-inline-flex align-items-center justify-content-center w-100 pr-2 pl-1"
    >Filters</span
  >
  }
</button>
} @if(showOrderTypeButtons()) {
<atx-segment-buttons
  [formControl]="orderTypeControl"
  [buttons]="localizedOrderTypeConfiguration()"
></atx-segment-buttons>
}

<atx-modal
  [show]="show$$ | async"
  [closeOnOutside]="true"
  [showCloseBtn]="false"
  (modalClose)="toggleModal(false); refreshAccordions()"
  data-e2e="filters-modal"
>
  <div class="modal-header position-relative flex-shrink-0">
    <div class="d-flex w-100 align-items-center justify-content-between">
      <span
        class="title"
        i18n="searchBar|Filters button text@@searchBarFiltersHeaderText"
      >
        {ctx.totalFilters, plural,=0 {Filters} =1 {Filters · 1} other {Filters ·
        {{ ctx.totalFilters }}}}</span
      >
      @if (ctx.isMobile) {
      <ng-container *ngTemplateOutlet="clearBtnTpl"></ng-container>
      } @else {
      <button
        [disabled]="ctx.productsLoading"
        (click)="toggleModal(false); refreshAccordions()"
        class="close-button"
        data-e2e="close-filters-modal-btn"
      >
        <fa-icon [icon]="['fas', 'xmark']"></fa-icon>
      </button>
      } @if (ctx.isMobile) {
      <ng-container *ngTemplateOutlet="closeBtnTpl"></ng-container>
      }
    </div>
  </div>
  <epc-search-filters-container></epc-search-filters-container>

  <div class="modal-footer flex-shrink-0">
    @if (!ctx.isMobile) {
    <ng-container *ngTemplateOutlet="clearBtnTpl"></ng-container>
    }
    <button
      [disabled]="ctx.productsLoading"
      class="btn btn-primary show-products"
      data-e2e="show-products-btn"
      (click)="showProducts()"
      i18n="
        filters|Products after filters are applied@@filtersBtnResultsCountText"
    >
      @if (ctx.productsLoading) {

      <fa-icon
        [icon]="['fas', 'spinner']"
        [spin]="true"
        [pulse]="true"
        class="m-auto"
      ></fa-icon>

      } @else { Show {{ ctx.resultCount }} products }
    </button>
  </div>
</atx-modal>
<ng-template #clearBtnTpl>
  <div class="clear-button">
    <button
      type="button"
      data-e2e="clear-all-btn"
      class="btn btn-link px-0 font-weight-medium text-decoration-underline"
      i18n="productBasket|Clear all filters text@@clearAllFilters"
      (click)="resetAll()"
    >
      Clear all
    </button>
  </div>
</ng-template>
<ng-template #closeBtnTpl>
  <button
    [disabled]="ctx.productsLoading"
    (click)="toggleModal(false); refreshAccordions()"
    class="close-button"
    data-e2e="close-filters-modal-btn"
  >
    <fa-icon [icon]="['fas', 'xmark']"></fa-icon>
  </button>
</ng-template>
}
